module.exports = __webpack_public_path__ + "img/step4.e7750b10.png";